export default "__VITE_ASSET__XPhueFqL__"